import React from 'react';
import styled from 'styled-components';
import { Modal, ModalHeader, ModalText, ModalTitle } from 'components/Modal';
import { theme, toRem } from 'design';
import Image from 'images/illustrations/Security.svg';

interface IProps {
  isActive: boolean;
  dataCy?: string;
  onClose: () => void;
}

const StyledImage = styled.img`
  display: block;
  width: 100%;
  max-width: ${toRem(300)};
  margin: 0 auto ${toRem(theme.space.xl)} auto;
`;

const MaintenanceModeModal = ({ isActive, onClose, dataCy = 'maintenance-mode-modal' }: IProps) => (
  <Modal isActive={isActive} onClose={onClose} maxWidth={640} dataCy={dataCy}>
    <ModalHeader>
      <StyledImage src={Image} alt="Maintenance Mode" />
      <ModalTitle>We are currently performing maintenance.</ModalTitle>
      <ModalText marginTop={8}>
        Our team is currently performing scheduled platform maintenance and system updates. During this time, some functionality may be temporarily unavailable or limited to ensure system stability and data integrity.
      </ModalText>
    </ModalHeader>
  </Modal>
);

export default MaintenanceModeModal;
